import { API_ENDPOINT, getLocalTimeHeader, getSearchParamsString } from './api';
import { SEND_METHOD } from 'enums/MemberVerification';

const urlSendVerificationCode = '/Member/SendVerificationCode';
const urlVerifyCode = '/Member/CheckVerificationCode';

const sendVerificationCode = async (
    toContact: string,
    channel: SEND_METHOD
) => {
    const url = `${API_ENDPOINT}${urlSendVerificationCode}?${getSearchParamsString(
        {
            toContact,
            channel,
        }
    )}`;

    return await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            ...getLocalTimeHeader(),
        },
    }).then((response) => response.json());
};

const verifyCode = async (
    toContact: string,
    verificationCode: string,
    channel: SEND_METHOD
) => {
    const url = `${API_ENDPOINT}${urlVerifyCode}?${getSearchParamsString({
        toContact,
        verificationCode,
        channel,
    })}`;

    return await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...getLocalTimeHeader(),
        },
    }).then((response) => response.json());
};

export { sendVerificationCode, verifyCode };
